export { default as TabNavigator } from './TabNavigator';
export * from './TabNavigator.consts';
export type { TabOption } from './TabNavigatorOption';
